import type { InvalidateQueryFilters, QueryClient } from '@tanstack/react-query'

/** Fire-and-forget cache invalidation without the `void` operator (Sonar S3735). */
export function invalidateQueriesSafe(
  qc: QueryClient,
  filters?: InvalidateQueryFilters,
): void {
  Promise.resolve(qc.invalidateQueries(filters)).catch(() => undefined)
}
